import { WhatsAppConversationDataType } from "../../types";
import EventBus from "../event-bus";
const conversationChangeHook = new EventBus<WhatsAppConversationDataType>(
  "conversationChangeHook"
);

export default conversationChangeHook;
